import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import AdminSideBar from '../../components/Admin/AdminSideBar'
import AdminAddProductsComp from '../../components/Admin/AdminAddProductsComp'
import Footer from '../../components/Layout/Footer'
import { ToastContainer } from 'react-toastify'
import AdminNavBar from '../../components/Admin/AdminNavBar'
import UseViewHide from '../../CustomHooks/UseViewHide'

const AdminAddProduct = () => {
  const [handleSideBarView, View] = UseViewHide()

  return (
    <>
      <AdminNavBar  handleSideBarView={handleSideBarView}/>
      <Container fluid>
        <Row>
          <Col xl="2" lg="3" className='dark-bg'>
            <AdminSideBar  View={View}/>
          </Col>

          <Col xl="10" lg="9">
            <AdminAddProductsComp />
          </Col>
        </Row>
      </Container>
      <Footer />
      <ToastContainer />
    </>
  )
}

export default AdminAddProduct
